import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import ContentAddCircle from '@material-ui/icons/AddCircle';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { addOrganization, fetchAllOrganizations } from './actions';
import OrganizationDialog from './Dialog';
import { UserRestriction } from '../../../common/components/UserRestiction';

@injectIntl
@connect(store => ({
  organizations: store.organizations,
}))
export default class SelectOrganization extends Component {
  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchAllOrganizations());
  }

  handleAdd = values => {
    const { dispatch } = this.props;
    return dispatch(addOrganization({ ...values }));
  };

  render() {
    const {
      input: { name, value, onChange },
      meta: { touched, error },
      intl: { formatMessage: f },
      labelKey,
      organizations,
    } = this.props;

    const label = labelKey ? f({ id: labelKey }) : f({ id: `field_${name}` });

    return (
      <div style={{ display: 'flex' }}>
        <FormControl fullWidth error={Boolean(touched && error)}>
          <InputLabel htmlFor={`select_${label}`}>{label}</InputLabel>
          <Select
            name={name}
            value={value}
            onChange={event => onChange(event.target.value)}
            input={<Input id={`select_${label}`} />}
            MenuProps={{
              PaperProps: { style: { maxHeight: 500 } },
            }}
          >
            {organizations &&
              organizations.list &&
              organizations.list.map(value => (
                <MenuItem value={value['@id']}>{value.name}</MenuItem>
              ))}
          </Select>
          {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
        <UserRestriction>
          <OrganizationDialog
            title="Création de l'organisateur"
            form="organization_add"
            onCreate={this.handleAdd}
          >
            {!organizations.adding && (
              <IconButton aria-label="add organization">
                <ContentAddCircle />
              </IconButton>
            )}
          </OrganizationDialog>
        </UserRestriction>
      </div>
    );
  }
}
